<template>
    <div class="prelative">
        <avatar-randomized v-if="currentLabel" 
            firstname="" 
            :lastname="currentLabel"
            class="pabsolute zi-1 select-input-avatar-randomized" 
            size="extra-small"/>
        <el-select 
            v-if="mode == 'edit'"
            :placeholder="placeholder" 
            :value="value" 
            @change="update" 
            :filterable="filterable"
            :disabled="disabled"
            :multiple="multiple"
            class="wp-10"
            :size="size"
            :popper-append-to-body="false"
            popper-class="custom-dropdown">
            <el-option
                v-if="selectNothing"
                :label="selectNothing"
                :value="null"/>
            <el-option
                v-for="option in options"
                :key="option[idColumn]"
                :label="option[labelColumn]"
                :value="option[idColumn]"
                :disabled="!!option.disabled">
                <avatar-randomized v-if="displayAvatar && displayAvatar.onOptions" firstname="" :lastname="option.label" size="extra-small" class="mr-1"/>
                <slot :option="option">{{ option[labelColumn] }}</slot>
            </el-option>
        </el-select>
        <p v-else>
            {{labelFromValue}}
        </p>
    </div>
</template>

<script>
    import AvatarRandomized from 'vcomponents/utilities/AvatarRandomized.vue';
    // import AvatarRandomized from 'vcomponents/utilities/AvatarRandomized.vue';

    export default {
        props: {
            mode: {
                type: String
            },
            value: {
                type: [Number, String, Object, Array],
                required: false,
                default: false
            },
            defaultValue:{
                type: String,
                required: false,
                default: ""
            },
            options: {
                type: Array,
                required: true,
                default: () => []
            },
            displayAvatar:{
                type: Object,
                required: false,
                default : () => {}
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            labelColumn: {
                type: String,
                required: false,
                default: 'label'
            },
            idColumn: {
                type: String,
                required: false,
                default: 'value'
            },
            filterable: {
                type: Boolean,
                required: false,
                default: false
            },
            multiple: {
                type: Boolean,
                required: false,
                default: false
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            selectNothing: {
                type: [String, Boolean],
                required: false,
                default: false
            },
            size: {
                type: String,
                required: false,
                default: "medium"
            }
        },
        components:{
                AvatarRandomized
        },
        data(){
            return {
                currentLabel : null
            }
        },
        mounted(){
            if(this.defaultValue && typeof this.defaultValue === "string" && this.displayAvatar){
                this.currentLabel = this.defaultValue;
            }
        },
        methods: {
            update(newValue){
                if(this.displayAvatar && this.displayAvatar.onSelect){
                    this.currentLabel = this.options.find(opt => opt.value === newValue)?.label;
                }
                this.$emit('input', newValue)
            }
        },
        computed: {
            labelFromValue(){
                return this.options.find(option => option[this.idColumn] == this.value)[this.labelColumn]
            }
        }
    }
</script>

<style lang="scss">
@import "~@sellsy/styleguide/src/_variables";

.el-select-dropdown.el-popper.custom-dropdown{
    box-shadow: 0 0 12px rgba(17, 17, 17, 0.24);
    border-radius: 6px;
    margin-top: 4px;
    .popper__arrow{
        display: none;
    }
    .el-select-dropdown__list {
        padding: 8px 0;
        .el-select-dropdown__item {
            border-radius: 4px;
            margin: 0 8px;
            padding: 0 8px;
        }
    }   
}
.select-input-avatar-randomized{
    top: 4px;
    left: 4px;
    & + .el-select input{
        padding-left: 38px;
    }
}
</style>